export default __webpack_public_path__ + "static/media/liiv-slider-proszek.6f657836.jpg";